import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function Popup(props) {
	return (
		<div>
			{/* 팝업창 */}
			{props.popupOpen ? (
				<div
					className="popup"
					style={{
						top: `${props.popupPosition.y - 40}px`,
						left: `${props.popupPosition.x}px`,
					}}
				>
					<header
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							marginBottom: '0.5rem',
							paddingLeft: '0.5rem',
						}}
					>
						<p style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>격자 ID: {props.popupData?.pc_grid_nm}</p>
						<IconButton onClick={() => props.setPopupOpen(false)}>
							<CloseIcon />
						</IconButton>
					</header>
					{/* <div>
						<p>격자 ID:</p>
						<p>{inPopupData?.pc_grid_nm}</p>
					</div> */}
					<div>
						<p>거주 인구수:</p>
						<p>{props.popupData?.pc_pop_r.toLocaleString('ko-KR')}명</p>
					</div>
					<div>
						<p>근무 인구수: </p>
						<p>{props.popupData?.pc_pop_w.toLocaleString('ko-KR')}명</p>
					</div>
					<div>
						<p>유입 중심성 지수:</p>
						<p>{props.popupData?.pc_in_val.toFixed(5)}</p>
					</div>
					<div>
						<p>유출 중심성 지수:</p>
						<p>{props.popupData?.pc_out_val.toFixed(5)}</p>
					</div>
				</div>
			) : null}
		</div>
	);
}
